// What a page reached from the manage link says about the confirmation number, shared by the
// cancellation page and the customer documents page (AB#774) so the two read the same.

export const NOT_FOUND_MESSAGE =
  "We couldn't find an upcoming appointment for that confirmation number. Please check the number in your text message and try again."

export const LOCKED_OUT_MESSAGE =
  "Too many attempts with an incorrect confirmation number. Please wait a few minutes and try again."
